import { MultiLanguageObject, SupportedLanguagesKeys } from "./diet.data.extractor";



//LINK - (Reference https://gitlab.eatme.cloud/contents/contents.nutrition_design/-/blob/main/20250827_Food_and_recipes_v171.xlsm?ref_type=heads)
const homemadeUnitValues =
    ["SMAB", "SMAC", "SMDD", "SMAD", "SMMD",
        "BIMD", "MEMD", "GARR", "GLAS", "HAND",
        "TABL", "TEAS", "UNIT", "BIGU", "MEDU",
        "PORT", "SLIC", "5CMS", "TERR", "CLOV",
        "PINC", "SPLA"] as const

export type HomemadeUnitType = typeof homemadeUnitValues[number]


export const HomemadeUnits: Record<HomemadeUnitType, { en: string, es: string, fr: string }> = {
    "SMAB": { en: "Small Bol", es: "Bol Pequeño", fr: "Petit bol" },
    "SMAC": { en: "Small Can", es: "Lata Pequeña", fr: "Petite boîte" },
    "SMDD": { en: "Small Dessert Dish", es: "Plato Pequeño de Postre", fr: "Petite assiette à dessert" },
    "SMAD": { en: "Small Dish", es: "Plato Pequeño", fr: "Petite assiette" },
    "SMMD": { en: "Small Main Dish", es: "Plato Pequeño en Cocido", fr: "Petite Assiette en Cuit" },
    "BIMD": { en: "Big Main Dish", es: "Plato Grande", fr: "Grand plat" },
    "MEMD": { en: "Medium Main Dish", es: "Plato Mediano", fr: "Assiette moyenne" },
    "GARR": { en: "Garrison", es: "Guarnición", fr: "Garnison" },
    "GLAS": { en: "Glass", es: "Vaso", fr: "Verre" },
    "HAND": { en: "Handful", es: "Puñado", fr: "Poignée" },
    "TABL": { en: "Tablespoon", es: "Cucharada Sopera", fr: "Cuillère à soupe" },
    "TEAS": { en: "Teaspoon", es: "Cucharadita de Café", fr: "Cuillère à café" },
    "UNIT": { en: "Unit", es: "Unidad", fr: "Unité" },
    "BIGU": { en: "Big Unit", es: "Unidad Grande", fr: "Grande Unité" },
    "MEDU": { en: "Medium Unit", es: "Unidad Mediana", fr: "Unité moyenne" },
    "PORT": { en: "Portion", es: "Porción", fr: "Portion" },
    "SLIC": { en: "Slice", es: "Rebanada", fr: "Tranche" },
    "5CMS": { en: "5cm Slice", es: "Rebanada de 5cm", fr: "Tranche de 5cm" },
    "TERR": { en: "Terrine", es: "Tarrina", fr: "Terrine" },
    "CLOV": { en: "Clove", es: "Diente", fr: "Gousse" },
    "PINC": { en: "Pinch", es: "Pizca", fr: "Pincée" },
    "SPLA": { en: "Splash", es: "Chorrito", fr: "Éclaboussure" }
} as const;





export const NUTRIENT_KEYS = [
    "b1_vitam",
    "b2_vitam",
    "b3_vitam",
    "b5_vitam",
    "b6_vitam",
    "b7_vitam",
    "b9_vitam",
    "b12_vitam",
    "c_vitam",
    "calcium",
    "carbohidrates",
    "carotenes",
    "ch_simple",
    "ch_starch",
    "chlorine",
    "chromium",
    "copper",
    "d_vitam",
    "e_vitam",
    "fat",
    "fat_MUFA",
    "fat_PUFA",
    "fat_SFAs",
    "fat_cholest",
    "fat_omg3",
    "fat_omg6",
    "fib_insoluble",
    "fib_soluble",
    "fiber",
    "fluorine",
    "h2O",
    "iodine",
    "iron",
    "k_vitam",
    "kcal",
    "magnesium",
    "manganese",
    "nickel",
    "phosphorus",
    "potassium",
    "proteins",
    "salt",
    "selenium",
    "sodium",
    "zinc"
] as const;

export type NutrientKey = (typeof NUTRIENT_KEYS)[number];



export const NUTRIENT_LABELS: Record<
    NutrientKey,
    Record<SupportedLanguagesKeys, string>
> = {
    b1_vitam: { en: "Vitamin B1", es: "Vitamina B1", fr: "Vitamine B1" },
    b2_vitam: { en: "Vitamin B2", es: "Vitamina B2", fr: "Vitamine B2" },
    b3_vitam: { en: "Vitamin B3", es: "Vitamina B3", fr: "Vitamine B3" },
    b5_vitam: { en: "Vitamin B5", es: "Vitamina B5", fr: "Vitamine B5" },
    b6_vitam: { en: "Vitamin B6", es: "Vitamina B6", fr: "Vitamine B6" },
    b7_vitam: { en: "Vitamin B7", es: "Vitamina B7", fr: "Vitamine B7" },
    b9_vitam: { en: "Vitamin B9", es: "Vitamina B9", fr: "Vitamine B9" },
    b12_vitam: { en: "Vitamin B12", es: "Vitamina B12", fr: "Vitamine B12" },
    c_vitam: { en: "Vitamin C", es: "Vitamina C", fr: "Vitamine C" },
    calcium: { en: "Calcium", es: "Calcio", fr: "Calcium" },
    carbohidrates: { en: "Carbohydrates", es: "Carbohidratos", fr: "Glucides" },
    carotenes: { en: "Carotenes", es: "Carotenos", fr: "Carotènes" },
    ch_simple: { en: "Simple sugars", es: "Azúcares simples", fr: "Sucres simples" },
    ch_starch: { en: "Starch", es: "Almidón", fr: "Amidon" },
    chlorine: { en: "Chlorine", es: "Cloro", fr: "Chlore" },
    chromium: { en: "Chromium", es: "Cromo", fr: "Chrome" },
    copper: { en: "Copper", es: "Cobre", fr: "Cuivre" },
    d_vitam: { en: "Vitamin D", es: "Vitamina D", fr: "Vitamine D" },
    e_vitam: { en: "Vitamin E", es: "Vitamina E", fr: "Vitamine E" },
    fat: { en: "Fat", es: "Grasas", fr: "Lipides" },
    fat_MUFA: { en: "Monounsaturated fat", es: "Grasas monoinsaturadas", fr: "Lipides monoinsaturés" },
    fat_PUFA: { en: "Polyunsaturated fat", es: "Grasas poliinsaturadas", fr: "Lipides polyinsaturés" },
    fat_SFAs: { en: "Saturated fat", es: "Grasas saturadas", fr: "Acides gras saturés" },
    fat_cholest: { en: "Cholesterol", es: "Colesterol", fr: "Cholestérol" },
    fat_omg3: { en: "Omega 3", es: "Omega 3", fr: "Oméga 3" },
    fat_omg6: { en: "Omega 6", es: "Omega 6", fr: "Oméga 6" },
    fib_insoluble: { en: "Insoluble fiber", es: "Fibra insoluble", fr: "Fibres insolubles" },
    fib_soluble: { en: "Soluble fiber", es: "Fibra soluble", fr: "Fibres solubles" },
    fiber: { en: "Fiber", es: "Fibra", fr: "Fibres" },
    fluorine: { en: "Fluorine", es: "Flúor", fr: "Fluor" },
    h2O: { en: "Water", es: "Agua", fr: "Eau" },
    iodine: { en: "Iodine", es: "Yodo", fr: "Iode" },
    iron: { en: "Iron", es: "Hierro", fr: "Fer" },
    k_vitam: { en: "Vitamin K", es: "Vitamina K", fr: "Vitamine K" },
    kcal: { en: "Calories", es: "Calorías", fr: "Calories" },
    magnesium: { en: "Magnesium", es: "Magnesio", fr: "Magnésium" },
    manganese: { en: "Manganese", es: "Manganeso", fr: "Manganèse" },
    nickel: { en: "Nickel", es: "Níquel", fr: "Nickel" },
    phosphorus: { en: "Phosphorus", es: "Fósforo", fr: "Phosphore" },
    potassium: { en: "Potassium", es: "Potasio", fr: "Potassium" },
    proteins: { en: "Proteins", es: "Proteínas", fr: "Protéines" },
    salt: { en: "Salt", es: "Sal", fr: "Sel" },
    selenium: { en: "Selenium", es: "Selenio", fr: "Sélénium" },
    sodium: { en: "Sodium", es: "Sodio", fr: "Sodium" },
    zinc: { en: "Zinc", es: "Zinc", fr: "Zinc" },
};


export function getNutrientLabel(key: NutrientKey, language: SupportedLanguagesKeys): string {
    return NUTRIENT_LABELS[key][language]
}
export function getMultilanguageNutrientLabels(key: NutrientKey): MultiLanguageObject {
    return NUTRIENT_LABELS[key]
}





// Mapping: nutrient key → unit
export const NUTRIENT_UNITS: Record<NutrientKey, string> = {
    // Vitamins
    b1_vitam: "mg",
    b2_vitam: "mg",
    b3_vitam: "mg",
    b5_vitam: "mg",
    b6_vitam: "mg",
    b7_vitam: "µg",
    b9_vitam: "µg",
    b12_vitam: "µg",
    c_vitam: "mg",
    d_vitam: "µg",
    e_vitam: "mg",
    k_vitam: "µg",

    // Minerals
    calcium: "mg",
    chlorine: "mg",
    chromium: "µg",
    copper: "mg",
    fluorine: "µg",
    iodine: "µg",
    iron: "mg",
    magnesium: "mg",
    manganese: "mg",
    nickel: "µg",
    phosphorus: "mg",
    potassium: "mg",
    selenium: "µg",
    sodium: "mg",
    zinc: "mg",

    // Macronutrients
    carbohidrates: "g",
    ch_simple: "g",
    ch_starch: "g",
    proteins: "g",
    fat: "g",
    fat_MUFA: "g",
    fat_PUFA: "g",
    fat_SFAs: "g",
    fat_cholest: "mg",
    fat_omg3: "g",
    fat_omg6: "g",
    fiber: "g",
    fib_insoluble: "g",
    fib_soluble: "g",
    h2O: "ml",

    // Energy
    kcal: "kcal",

    // Extras
    carotenes: "µg",
    salt: "g",
};


function formatNutrient(key: NutrientKey, value: number): string {
    return `${value} ${NUTRIENT_UNITS[key]}`;
}






const cookingAuxiliars = ["AIRF", "KITC", "MICRO", "OVEN", "PROG", "WIAU"] as const
export type CookingAuxiliarType = typeof cookingAuxiliars[number]



export const COOKING_AUXILIAR_KEYS: Record<
    CookingAuxiliarType,
    Record<SupportedLanguagesKeys, string>
> = {
    AIRF: { en: "Air fryer", es: "Freidora de aire", fr: "Friteuse à air" },
    KITC: { en: "Kitchen robot", es: "Robot de cocina", fr: "Robot de cuisine" },
    MICRO: { en: "Microwave", es: "Microondas", fr: "Microonde" },
    OVEN: { en: "Oven", es: "Horno", fr: "Four" },
    PROG: { en: "Programmable pot", es: "Olla programable", fr: "Marmite programmable" },
    WIAU: { en: "Without Auxiliar", es: "Sin Auxiliar", fr: "Sans aide" }
};

export function getCookingAuxiliarLabel(kitchenAuxiliarType: CookingAuxiliarType, language: SupportedLanguagesKeys): string {
    return COOKING_AUXILIAR_KEYS[kitchenAuxiliarType][language]
}
export function getMultilanguageCookingAuxiliarLabel(kitchenAuxiliarType: CookingAuxiliarType): MultiLanguageObject {
    return COOKING_AUXILIAR_KEYS[kitchenAuxiliarType]
}




const cookingProcedures = ["BOIL", "BAKE", "GRIL", "NONT", "STIR"] as const
export type CookingProcedureType = typeof cookingProcedures[number]

const COOKING_PROCEDURE_KEYS: Record<CookingProcedureType, Record<SupportedLanguagesKeys, string>> = {
    BOIL: {
        en: "Boiled", es: "Hervido", fr: "Bouilli",
    },
    BAKE: {
        en: "Baked", es: "Horneado", fr: "Au four",
    },
    GRIL: {
        en: "Grilled", es: "A la plancha", fr: "Grillé",
    },
    NONT: {
        en: "Not cooked", es: "No cocinado", fr: "Pas cuit",
    },
    STIR: {
        en: "Stir fry", es: "Salteado", fr: "Sauté",
    }
}

export function getCookingProcedureLabel(cookingProcedure: CookingProcedureType, language: SupportedLanguagesKeys): string {
    return COOKING_PROCEDURE_KEYS[cookingProcedure][language]
}
export function getMultilanguageCookingProcedureLabel(cookingProcedure: CookingProcedureType): MultiLanguageObject {
    return COOKING_PROCEDURE_KEYS[cookingProcedure]
}
